var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.009 58.54C14.49 56.196 5.001 45.198 5.001 32 5 17.099 17.099 5 32 5s27 12.098 27 27c0 13.195-9.484 24.19-22 26.538V46c0-2.66-.959-5.098-2.036-7h.636c5.74 0 10.4-3.764 10.4-8.4v-1.293c0-2.96-1.412-5.657-3.72-7.674 1.297-3.148.446-6.634.446-6.634s-3.517 1.027-5.586 3.788a16.886 16.886 0 0 0-5.14-.788c-1.814 0-3.548.28-5.14.788C24.792 16.028 21.275 15 21.275 15s-.851 3.486.447 6.634c-2.309 2.017-3.721 4.713-3.721 7.674V30.6c0 4.637 4.66 8.4 10.4 8.4h.636c-.941 1.662-1.791 3.733-1.991 6l-.004 1.244c-2.168.103-5.551-.264-7.041-3.243-2-4-6-1-6-1 3 0 3.045 4 5.045 6 1.983 1.984 5.697 2.219 7.986 2.15l-.023 8.389Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a391e2b079b81bde825c24e50df89f5e.svg";
export { ForwardRef as ReactComponent };